<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.0019 0.00390625C8.95791 0.00390625 0.00390625 8.95791 0.00390625 20.0019C0.00390625 29.9819 7.31591 38.2539 16.8779 39.7599V25.7839H11.7979V20.0019H16.8779V15.5959C16.8779 10.5799 19.8639 7.81391 24.4299 7.81391C26.6179 7.81391 28.9099 8.20391 28.9099 8.20391V13.1219H26.3819C23.9019 13.1219 23.1259 14.6659 23.1259 16.2479V19.9979H28.6679L27.7819 25.7799H23.1259V39.7559C32.6879 38.2579 39.9999 29.9839 39.9999 20.0019C39.9999 8.95791 31.0459 0.00390625 20.0019 0.00390625Z" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'FacebookIcon'
}
</script>
